import React from 'react';
import Allproducts from '../../ProductSections/Allproducts/Allproducts';
import Nevigetions from '../../Shared/Nevigetions/Nevigetions';

const Productsorder = () => {
    return (
        <div>
            <Nevigetions></Nevigetions>
            <Allproducts></Allproducts>
        </div>
    );
};

export default Productsorder;